import CatalogSubCategories from '~/themes/base/components/catalog/CatalogSubCategories'
import CatalogSubCategoryBox from '~/themes/oknadverenamiru/components/catalog/CatalogSubCategoryBox'

export default {
  extends: CatalogSubCategories,
  components: {
    CatalogSubCategoryBox,
  },
}
